export const ACTION_CP_OVERVIEW = '/clientteling/cpoverview';

export const GET_SO_CARTS = '/OsimCart/GetSOCarts';